<template>
  <div class="bg-gray">
    <div class="form-content">

      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="申报时间" prop="year"
                          :rules="[
                { required: true, message: '请选择年份', trigger: 'blur' },
              ]"
            >
              <el-radio-group v-model="formData.year">
                <el-radio :label="item" v-for="item in columns" :key="item">{{ item }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
                label="领取的比赛或活动名称"
            >
              <div v-if="formData.extra_saiqu.length > 0" style="cursor: pointer" @click="showSaiquPicker = true">
                {{ formData.extra_saiqu[0].name }}
              </div>
              <div v-else style="cursor: pointer" @click="showSaiquPicker = true">点击选择领取的比赛或活动名称 <i
                  class="el-icon-arrow-right"></i></div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="领取地址"
                prop="area"
                :rules="[
                {
                  required: true,
                  message: '点击选择省市区',
                },
              ]"
            >
              <el-cascader
                  v-model="formData.area"
                  ref="areas"
                  @change="handleAreasChange"
                  :options="areaOptions"
                  :props="{ label: 'title' }"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="领取日期"
                prop="getdate"
                :rules="[
                { required: true, message: '请选择领取日期', trigger: 'blur' },
              ]"
            >
              <el-date-picker
                  v-model="formData.getdate"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="请选择领取日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="领取单位"
                prop="danwei"
                :rules="[
                { required: true, message: '单位名称不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.danwei"
                  type="text"
                  placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="联系人"
                prop="name"
                :rules="[
                { required: true, message: '联系人名称不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.name"
                  type="text"
                  placeholder="请输入联系人名称"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="电话"
                prop="phone"
                :rules="[
              ]"
            >
              <el-input
                  v-model="formData.phone"
                  type="text"
                  placeholder="请输入电话"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <div v-for="(subject,index) in formData.member_list">
          <el-divider>四好运动员信息{{ index + 1 }}</el-divider>
          <el-row>
            <el-col :span="12">
              <el-form-item
                  label="姓名"
                  :prop="'member_list.'+index + '.name'"
                  :rules="[
                { required: true, message: '请输入姓名', trigger: 'blur' },
              ]"
              >
                <el-input
                    v-model="subject.name"
                    type="text"
                    placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  label="身份证号"
                  :prop="'member_list.'+index + '.num'"
                  :rules="[
                { required: true, validator: validator.idCard,message:'请输入正确的身份证号', trigger: ['blur', 'change'] },
              ]"
              >
                <el-input
                    v-model="subject.num"
                    type="text"
                    placeholder="请输入身份证号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>

            <el-col :span="12">
              <el-form-item
                  label="民族"
                  :prop="'member_list.'+index + 'mingzu'"
              >
                <el-input
                    v-model="subject.mingzu"
                    type="text"
                    placeholder="请输入民族"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  label="学段"
                  :prop="'member_list.'+index + 'xueduan'"
                  :rules="[
              ]"
              >
                <el-input
                    v-model="subject.xueduan"
                    type="text"
                    placeholder="请输入学段"
                ></el-input>
                <div class="form-label-desc mt10">“学段”可填：幼儿园、小学、初中、高中、大学</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item
                  label="品德得分"
                  :prop="'member_list.'+index + 'score_pingde'"
              >
                <el-input
                    v-model="subject.score_pingde"
                    type="number"
                    placeholder="请输入品德得分"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  label="学段得分"
                  :prop="'member_list.'+index + 'score_xuexi'"
                  :rules="[
              ]"
              >
                <el-input
                    v-model="subject.score_xuexi"
                    type="number"
                    placeholder="请输入学段得分"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                  label="气质得分"
                  :prop="'member_list.'+index + 'score_qizhi'"
              >
                <el-input
                    v-model="subject.score_qizhi"
                    type="number"
                    placeholder="请输入气质得分"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  label="技术得分"
                  :prop="'member_list.'+index + 'score_jishu'"
                  :rules="[
              ]"
              >
                <el-input
                    v-model="subject.score_jishu"
                    type="text"
                    placeholder="请输入技术得分"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>

            <el-col :span="12">
              <el-form-item
                  label="投票得分"
                  :prop="'member_list.'+index + 'score_toupiao'"
              >
                <el-input
                    v-model="subject.score_toupiao"
                    type="number"
                    placeholder="请输入投票得分"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="footer-button">
            <el-button
                size="normal" round icon="el-icon-close" @click="memberRemove(subject,index)">删除运动员
            </el-button>
          </div>
        </div>
        <el-row>
          <el-col class="footer-button">
            <el-button round icon="el-icon-plus" @click="memberAdd">新增运动员
            </el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">提交申请</el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain v-if="false">重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>
      <SaiquPicker
          :show="showSaiquPicker"
          :limit="1"
          :value="formData.extra_saiqu"
          @onChange="onSaiquChange"
          @onClose="showSaiquPicker=false"
          :defaultValue="formData.extra_saiqu"
          @onConfirm="onSaiquConfirm"
      ></SaiquPicker>


    </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}


.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import FileUploaderData from '@/components/picker/FileUploaderData.vue';
import SaiquPicker from '@/components/picker/SaiquPicker.vue';
import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button, Dialog
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'ClubDetailSihaoApply',
  components: {
    FileUploaderData, SaiquPicker
  },
  data: function () {
    return {
      validator,
      saveLoading: false,
      formValidate: false,
      showArea: false,
      showDate: false,
      showPicker: false,
      showSaiquPicker: false,
      areaList: {},
      areaOptions: [],
      areaValue: '',
      submitType: '',

      minDate: new Date(2000, 1, 1),
      maxDate: new Date(2030, 12, 30),
      currentDate: new Date(),
      columns: [2021, 2020, 2019, 2018, 2017, 2016, 2015],
      formData: {
        id: 0,
        stationid: '',
        year: '',
        getdate: '',
        getaddress: '',
        danwei: '',
        name: '',
        phone: '',
        xlssrc: [], //excel模板文件
        extra_saiqu: [],
        member_list: [],
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "申报四好运动员"
    that.areaList = area;
    that.id = this.$route.query.id;
    that.getAreaOptions()
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (res) => {
        that.areaOptions = res.data;
        that.namekeyList = res.data;
      });
    },
    handleAreasChange(values) {
      let data = this.$refs.areas.getCheckedNodes()[0].pathLabels;
      console.log("handleAreasChange", values, data);
      this.formData.area = values[2];
      this.formData.province = data[0];
      this.formData.city = data[1];
      this.formData.county = data[2];
    },
    onConfirm(value) {
      this.formData.year = value;
      this.showPicker = false;
    },

    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },

    onSaiquChange(values) {
      console.log('onSaiquChange', values)
      this.formData.extra_saiqu = [...values];
    },
    onSaiquConfirm(values) {
      console.log('onJianduConfirm', values)
      this.showSaiquPicker = false;
      this.formData.extra_saiqu = [...values];
    },
    onDateConfirm(date) {
      this.showDate = false;
      this.formData.getdate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      console.log('onDateConfirm', this.formData);

    },

    memberAdd() {
      if (this.formData.member_list.length > 0) {
        let lastRow = this.formData.member_list[this.formData.member_list.length - 1]
        if (!lastRow.name) {
          this.$message.warning('请输入姓名');
          return
        }
        if (!lastRow.num) {
          this.$message.warning('请输入身份证号');
          return
        }
      }

      this.formData.member_list.push({
        id: 0,
        name: '',
        num: '',
        mingzu: '',
        xueduan: '',
        score_pingde: '',
        score_xuexi: '',
        score_qizhi: '',
        score_jishu: '',
        score_toupiao: '',
      })
    },
    memberRemove(item, index) {
      let that = this;
      let notice = '确认删除项目' + (item.subject_name ? '(' + item.subject_name + ')' : '') + '吗?';
      that.formData.member_list.splice(index, 1);
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      console.log(that.formData, that.$refs[formName]);
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          console.log(that.formData);
          // return
          for (let field in that.formData) {

            if (!that.formData.year) {
              that.$message.warning('请选择年份');
              return
            }
            if (!that.formData.extra_saiqu.length) {
              that.$message.warning('请选择领取的比赛或活动名称');
              return
            }

            if (!that.formData.area) {
              that.$message.warning('请输入领取地点');
              return
            }
            if (!this.formData.danwei) {
              that.$message.warning('请输入领取单位');
              return
            }

            if (!this.formData.member_list.length) {
              that.$message.warning('请输入四好运动员信息');
              return
            }
          }

          that.formData.stationid = that.formData.extra_saiqu[0].id
          that.saveLoading = true;

          that.$api.post('/api/cSihao/apply', that.formData, (res) => {
            that.saveLoading = false;
            that.$message.success('新增成功')
            rbLink({
              name: "ClubDetailSihao",
            }, 'back')
          }, (res) => {
            that.$message.warning(res.msg);
            that.saveLoading = false;
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;


      for (let field in that.formData) {

        if (!that.formData.year) {
          Toast('请选择年份');
          return
        }
        if (!that.formData.extra_saiqu.length) {
          Toast('请选择领取的比赛或活动名称');
          return
        }

        if (!that.formData.area) {
          Toast('请输入领取地点');
          return
        }
        if (!this.formData.danwei) {
          Toast('请输入领取单位');
          return
        }
      }

      that.formData.stationid = that.formData.extra_saiqu[0].id
      that.saveLoading = true;

      if (that.submitType == 'save') {
        that.$api.post('/api/examecenter/save', that.formData, (res) => {
          that.saveLoading = false;
        }, (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        })
      } else {
        that.$api.post('/api/cSihao/apply', that.formData, (res) => {
          that.saveLoading = false;
          Toast.success('新增成功')
          rbLink({
            name: "ClubDetailSihao",
          }, 'back')
        }, (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        })
      }
    },

    onGetData(data) {
      console.log('onGetData', data)
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },
  }
}
</script>



// WEBPACK FOOTER //
// ClubDetailSihaoApply.vue?c0909c7c